// src/Lexprompt/pages/Templates.js

export const builtinTemplates = [
    {
      id: "template1",
      title: "Facebook Ad Copy",
      department: "Marketing",
      visibility: "Public",
      body: "Generate headline & body for Facebook ads",
      resultMedia: [],
    }
  ];
  